import { EinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/EinstellungenFormContext';
import { useContext } from 'react';

export function useEinstellungenFormContext() {
  const context = useContext(EinstellungenFormContext);

  if (!context) {
    throw new Error(
      'EinstellungenFormContext must be used within EinstellungenFormProvider',
    );
  }
  return context;
}
